// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question1-container {
    gap: var(--dl-space-space-unit);
    flex: 1 1;
    width: auto;
    height: auto;
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
}
.question1-text {
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/components/question1.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,SAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".question1-container {\r\n    gap: var(--dl-space-space-unit);\r\n    flex: 1;\r\n    width: auto;\r\n    height: auto;\r\n    display: flex;\r\n    position: relative;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n}\r\n.question1-text {\r\n    font-weight: 700;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
